function initTopBarSlider() {
    const sliderWrapper = document.querySelectorAll('.top-bar__wrapper');
    sliderWrapper.forEach(wrapper => {
        if (!wrapper) return;

        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#top-bar-' + id);
        const nextElement = wrapper.querySelector('.swiper-button-next');
        const prevElement = wrapper.querySelector('.swiper-button-prev');

        if (!container) return;

        if (container.swiper) {
            container.swiper.destroy();
        }

        let swiper = new Swiper(container, {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: nextElement,
                prevEl: prevElement,
            },
        });
    });
}
document.addEventListener("DOMContentLoaded", function () {
    initTopBarSlider();
});